/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and
 * international treaties. Unauthorized use, reproduction, distribution, or
 * modification of any content from Knowledge for Decisions (K4D) is strictly
 * prohibited. For inquiries regarding the use or licensing of K4D's
 * copyrighted materials, please contact us at contact@k4d.com.br. "Knowledge
 * for Decisions (K4D)" and the slogan "Using data to make precise decisions"
 * are registered trademarks of Knowledge for Decisions (K4D).
 */

import React from 'react';
import { Text } from '@/shared/ui';
import { errorStyle } from './drawer-styles';

/**
 * Validation message for a single drawer field.
 *
 * Renders nothing when there is no message, so callers can drop it under any
 * input unconditionally. `role="alert"` announces the message to assistive
 * technology as soon as validation surfaces it.
 *
 * @param props.message - The localized error message, if any.
 * @returns The rendered message, or null.
 */
export const FieldError: React.FC<{ message?: string }> = ({ message }) => {
  if (!message) return null;
  return (
    <Text component="span" role="alert" style={errorStyle}>
      {message}
    </Text>
  );
};
